// DynamicZoneInputItem.tsx
import {
  FileInput,
  SelectInput,
  ImageField,
  required
} from 'react-admin';
import { useState } from 'react';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';
import { useWatch, useFormContext } from 'react-hook-form';
import { RichTextInput } from 'ra-input-rich-text';

const componentOptions = [
  { id: 'shared.rich-text', name: 'Texto Enriquecido' },
  { id: 'shared.media', name: 'Imagen' },
];

export const DynamicZoneInputItem = ({
  source,
  index,
  isEditing = false,
  onRemove,
}: {
  source: string;
  index: number;
  isEditing?: boolean,
  onRemove: () => void;
}) => {
  const [imageChanged, setImageChanged] = useState(false);
  const { control } = useFormContext();

  const componentType = useWatch({
    control,
    name: `${source}.${index}.__component`,
  });

  return (
    <div
      style={{
        border: '1px solid #ccc',
        padding: 10,
        marginBottom: 40,
      }}
    >
      <SelectInput
        source={`${source}.${index}.__component`}
        choices={componentOptions}
        label="Tipo de componente"
        fullWidth
      />

      {componentType === 'shared.rich-text' && !isEditing && (
        <RichTextInput
          source={`${source}.${index}.contenido`}
          label="Texto enriquecido"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
      )}

      {componentType === 'shared.rich-text' && isEditing && (
        <RichTextInput
          source={`${source}.${index}.contenido`}
          label="Texto enriquecido"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
      )}

      {componentType === 'shared.media' && !isEditing && (
        <FileInput
          source={`${source}.${index}.media`}
          label="Archivo multimedia"
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
      )}

      {componentType === 'shared.media' && isEditing && (
        <FileInput
          source={`${source}.${index}.imagen`}
          label="Archivo multimedia"
          validate={[required()]}
          onChange={() => setImageChanged(true)}
        >
          {
            isEditing && (
              <>
                {imageChanged && <ImageField source="src" />}
                {!imageChanged && <ImageField source="url" />}
              </>
            )
          }
        </FileInput>
      )}

      <button type="button" onClick={onRemove}>
        Eliminar
      </button>
    </div>
  );
};
